import { TodoForm } from "features/TodoOploggSidebar/formSchema";
import { useTranslation } from "react-i18next";
import { MenuCheckboxItem, MenuItemGroup } from "shared/components/Spor";

import { useFormContext } from "react-hook-form";
import { Dropdown } from "shared/components/forms/Dropdown";
import { RenderErrorInPath } from "shared/components/forms/RenderErrorInPath";
import {
  getSelectedTodoRoleCount,
  getUpdatedRoles,
  TODO_ROLES,
  UserRole,
} from "shared/types/roles";

export const RoleOptions = () => {
  const {
    formState: { errors },
    watch,
    setValue,
  } = useFormContext<TodoForm>();
  const value = (watch("roles") ?? []) as UserRole[];
  const { t } = useTranslation();
  const allRoles = TODO_ROLES.reduce<UserRole[]>(
    (selectedRoles, role) => getUpdatedRoles(selectedRoles, role.value),
    [],
  );
  const allRolesSelected =
    allRoles.length > 0 && allRoles.every((role) => value.includes(role));

  return (
    <>
      <Dropdown
        label={t("Del med")}
        selectedAmount={getSelectedTodoRoleCount(value)}
        width="100%"
      >
        <MenuItemGroup>
          <MenuCheckboxItem
            value="toggle-all-roles"
            checked={allRolesSelected}
            onCheckedChange={() =>
              setValue("roles", allRolesSelected ? [] : allRoles)
            }
          >
            {t("Marker alle")}
          </MenuCheckboxItem>
          {TODO_ROLES.map((role) => (
            <MenuCheckboxItem
              key={role.value}
              value={role.value}
              checked={value.includes(role.value)}
              onCheckedChange={() =>
                setValue("roles", getUpdatedRoles(value, role.value))
              }
            >
              {role.text}
            </MenuCheckboxItem>
          ))}
        </MenuItemGroup>
      </Dropdown>

      {value && value.length === 0 && (
        <RenderErrorInPath
          errors={errors}
          errorPath="roles"
          position="absolute"
          pt={8}
          pointerEvents="none"
        />
      )}
    </>
  );
};
